import { createServerFn } from '@tanstack/react-start';
import api from '../utils/api';

export const getMapDataByCountry = createServerFn()
    .validator((data) => data)
    .handler(async ({ data }) => {
        const { destinationId } = data;
        const response = await api('get', `mapdata/country/${destinationId}`);
        return response.data || [];
    });
